import GroupWorkIcon from '@mui/icons-material/GroupWork';
import { IconButton } from '@mui/material';

import { BaseActionProps } from '../types';

export const Group: React.FC<BaseActionProps> = (props) => {
  const { disabled, onClick, type } = props;

  return (
    <IconButton
      type={type}
      disabled={disabled}
      color="primary"
      size="medium"
      onClick={onClick}
    >
      <GroupWorkIcon />
    </IconButton>
  );
};
